<template>
  <modal id="fleetsForm"
         v-model="visible"
         :title="id ? $t('a-fleetsForm:updateFleet') : $t('a-fleetsForm:createFleet')"
         :callback="id ? updateFleet : createFleet"
         @modal:cancel="$emit('cancel')"
  >
    <small slot="modal-header-right" class="text-muted font-italic">{{ $t('a-fleetsForm:required') | capitalize }}</small>

    <div slot="modal-body">
      <div v-if="isRole.superAdmin" class="form-group">
        <label for="customer" class="control-label">{{ $t('a-fleetsForm:customer') | capitalize }} *</label>
        <select id="customer"
                v-model="customer"
                v-validate="{required: isRole.superAdmin}"
                :data-vv-as="$t('a-fleetsForm:customer')"
                :class="{ 'is-invalid': errors.has('customer') }"
                name="customer"
                class="form-control"
        >
          <option v-for="c in $store.getters.customers" :key="c.id" :value="c" :data-customer-id="c.id">{{ c.name }}</option>
        </select>
        <div class="invalid-feedback">{{ errors.first('customer') }}</div>
      </div>

      <div class="form-group">
        <label for="name" class="control-label">{{ $t('a-fleetsForm:name') | capitalize }} *</label>
        <input id="name"
               v-model="name"
               v-validate="'required|text'"
               :data-vv-as="$t('a-fleetsForm:name')"
               :class="{ 'is-invalid': errors.has('name') }"
               type="text"
               name="name"
               class="form-control"
        >
        <div class="invalid-feedback">{{ errors.first('name') }}</div>
      </div>
    </div>
  </modal>
</template>

<script>
import { pick, find } from 'lodash-es'
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

export default {
  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    // Display or hide modal
    // To be used as v-model
    show: {
      type: Boolean,
      required: true
    },

    fleetToEdit: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      // Display or hide b-modal
      // It cannot change our props, so we need another variable
      visible: false,
      // Form
      id: '',
      name: '',
      customer: null
    }
  },

  watch: {
    // Synchronize show and visible
    // Use change event to update v-model
    show () {
      this.reset()
      this.visible = this.show

      if (this.show && this.isRole.superAdmin) {
        this.$store.dispatch('getCustomers').then(() => {
          if (this.id) this.customer = find(this.$store.getters.customers, customer => customer.id === this.fleetToEdit.customer.id)
        })
      } else if (!this.isRole.superAdmin) {
        this.customer = this.$store.getters.authenticatedUserCustomer
      }
    },
    visible () {
      this.$emit('change', this.visible)
    },

    fleetToEdit () {
      if (this.fleetToEdit) {
        this.id = this.fleetToEdit.id
        this.name = this.fleetToEdit.name
      }
    }
  },

  methods: {
    async reset () {
      this.id = ''
      this.name = ''
      this.customer = null

      // Reset form validation
      await this.$nextTick()
      this.$validator.reset()
    },

    async createFleet () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      const fleet = pick(this, ['name'])
      fleet.customer = { id: this.customer.id }

      let error
      [error] = await to(this.$api.createFleet(this.$store.getters.application, fleet))
      if (error) return

      this.visible = false
      // Success
      eventBus.$emit('message-success', this.$t('a-fleetsForm:createSuccess', { fleet: this.name }))
      // Reset form
      this.reset()
      // Refresh list
      this.$emit('success')
    },

    async updateFleet () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      const fleet = pick(this, ['name'])
      fleet.customer = { id: this.customer.id }

      let error
      [error] = await to(this.$api.updateFleet(this.fleetToEdit, fleet))
      if (error) return

      this.visible = false
      // Update selection
      this.$store.commit('updateFleetInSelection', { id: this.id, name: this.name })
      // Success
      eventBus.$emit('message-success', this.$t('a-fleetsForm:editSuccess', { fleet: this.name }))
      // Reset form
      this.reset()
      // Refresh list
      this.$emit('success')
    }
  }
}
</script>
